import React from 'react'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import { reducer } from './PerformanceReducer'
import { withSuspenseWrapper } from '../../SuspenseWrapper'
import { WidgetsState, WidgetsMessage, WidgetsConfig } from './types'
import { type, name, description } from './utils'

const WrapperWidget = withSuspenseWrapper(React.lazy(() => import('./PerformanceWidget')))

widgetService.register({
    type,
    name,
    description,
    config: {
        color: 'red'
    },
    policies: {
        handleOwnMissingData: true
    },
    impl: reactWidgetWrapper<WidgetsState, WidgetsMessage, WidgetsConfig>(WrapperWidget, reducer)
})
